import styled from "styled-components";

export const WrapperSpot = styled.div`
  background-color: ${(props) => props.theme.colors.DTBlue};
`;
